<template>
  <div class="ibc-org-certificate common-certificate">
    <action-bar>
      <btn-style :btn-list="btnList"></btn-style>
    </action-bar>
    <normal-table
      ref="commonTable"
      :table-col="tableCol"
      :table-data="orgList"
      :first-table-col="firstTableCol"
      :operator="operator"
      :operate-col="operateCol"
      :show-edit="true"
      :paging="orgPaging"
      @pagination="handleSizeOrPageChange"
    >
    <template slot="status" slot-scope="{ param }">
        <span class="cert-status" :class="param.row.Status === 'normal'?'is-normal':'is-cancel'">{{
          formatStatus(param.row.Status) || $constants.EMPTY
        }}</span>
      </template>
    </normal-table>
    <init-org ref="initOrg" @update:list="getList()"></init-org>
    <import-org ref="importOrg" @update:list="getList()"></import-org>
    <see-dialog ref="seeDialog"></see-dialog>
    <gen-org ref="genOrg" @update:list="getList()"></gen-org>
  </div>
</template>

<script>
import auth from '@/auth/index'
import { mapState, mapActions } from 'vuex'
import initOrg from './components/initOrg'
import importOrg from './components/importOrg'
import seeDialog from './components/seeDialog'
import genOrg from './components/genOrg'
export default {
  name: 'Organization',
  components: {
    initOrg,
    importOrg,
    seeDialog,
    genOrg
  },
  data() {
    return {
      btnList: [
        {
          btnContent: '生成IBC组织证书',
          click: () => {
            return this.genOrg()
          },
          icon: 'icon-gen',
          auth: auth.certificate.IBCAuth.orgCert.createOrgCert
        },
        // {
        //   btnContent: '导入IBC组织证书',
        //   click: () => {
        //     return this.importOrg()
        //   },
        //   icon: 'icon-import',
        //   auth: auth.certificate.IBCAuth.orgCert.importOrgCert
        // },
        // {
        //   btnContent: '申请IBC组织证书',
        //   click: () => {
        //     return this.initOrg()
        //   },
        //   icon: 'icon-apply',
        //   auth: auth.certificate.IBCAuth.orgCert.requireOrgCert
        // }
      ],
      // 设置table的列
      tableCol: [
        { 
          prop: 'OrgId', 
          label: '组织ID',
          minWidth: 197 
        },
        { 
          prop: 'OrgName', 
          label: '组织名称',
          minWidth: 165 
        },
        {
          prop: 'CertUse',
          label: '证书用途',
          formatter: row => {
            return this.formatUsage(row.CertUse)
          },
          minWidth: 163
        },
        {
          prop: 'Algorithm',
          label: '密码算法',
          formatter: row => {
            return this.formatAlgo(row.Algorithm)
          },
          minWidth: 78
        },
        {
          prop: 'Status',
          label: '状态',
          minWidth: 182,
          slotName: 'status',
          align: 'center',
          headerAlign: 'center',
        },
        {
          prop: 'createAt',
          label: '创建时间',
          formatter: row => {
            return this.formatTime(row)
          },
          minWidth: 164
        }
      ],
      // table的基本操作
      operator: [
        {
          text: '查看公钥',
          showText: true,
          click: (row, col, cellValue) => {
            return this.getInfo(row, col, cellValue)
          },
          icon: 'icon-check'
        },
        {
          text: '下载',
          showText: true,
          click: (row, col, cellValue) => {
            return this.downloadFile(row)
          },
          icon: 'icon-download'
        },
        {
          text: '撤销',
          showText: true,
          click: (row, col, cellValue) => {
            return this.delInfo(row)
          },
          icon: 'icon-cancel',
          formatter: row => {
            return this.judgeShow(row)
          }
        }
      ],
      operateCol: {
        minWidth: 208
      },
      firstTableCol: {
        select: false,
        type: 'selection'
      }
    }
  },
  computed: {
    ...mapState({
      orgList: state => state.certificate.org_list,
      orgPaging: state => state.certificate.org_paging
    })
  },

  mounted() {
    this.getList()
  },
  methods: {
    ...mapActions(['getOrgLists']),
    getList(limit = 20, offset = 0, name) {
      let params = {
        offset,
        limit,
        certType: 0,
        name,
        chainMode: 'permissionedWithIBC'
      }
      this.getOrgLists(params)
    },
    handleSizeOrPageChange(data) {
      const { offset, limit } = data // TODO: 这里的 offset 实际是 page，后续需要修改一下 src/components/commonTable/index.vue 中的 this.$emit('pagination') 的 data
      let limit2 = limit * 2 // IBC 同一份完整的证书，包含sign证书和tls证书，二者分为两条数据，前端获取后会合并当做一条数据，所以每次取2倍的数据量
      this.getList(limit2, offset * limit2)
    },
    formatTime(row) {
      return this.$utils.dateFormat('YYYY-mm-dd HH:MM', row.createAt)
    },
    formatAlgo(algo) {
      // return algo === 0 ? '国密' : 'ECDSA'
      switch (algo) {
        case 0:
          return '国密'
        case 1:
          return 'ECDSA'
        default:
          return 'IBC'
      }
    },
    formatUsage(usage) {
      // switch (usage) {
      //   case 0:
      //     return '签名'
      //   case 1:
      //     return '通信'
      //   case 2:
      //     return 'PEM'
      //   case 3:
      //     return 'IBC签名'
      //   case 4:
      //     return 'IBC通信'
      //   default:
      //     return '未知用途:' + usage
      // }
      return 'IBC通信/IBC签名'
    },
    formatStatus(status) {
      return status === 'normal' ? '正常' : '已撤销'
    },
    initOrg() {
      this.$refs.initOrg.handleOpen()
    },
    importOrg() {
      this.$refs.importOrg.handleOpen()
    },
    genOrg() {
      this.$refs.genOrg.handleOpen()
    },
    //查看公钥方法
    getInfo(row, col, cellValue) {
      let data = {
        cert: row.Cert,
        //title: row.OrgName
        id: row.OrgId,
        name: row.OrgName,
        title: '查看公钥',
        index: '_ORG_',
        sign: row.Cert3,
        communication: row.Cert4,
        type: 'IBC'
      }
      this.$refs.seeDialog.handleOpen(data)
    },
    downloadFile(row) {
      const nameSign = row.OrgId + '_ORG_' + row.OrgName + '签名.key'
      const nameCommunication = row.OrgId + '_ORG_' + row.OrgName + '通信.key'

      // this.$utils.createFileAndDownload(name, row.Cert)
      this.$utils.createFileAndDownload(nameSign, row.Cert3)
      this.$utils.createFileAndDownload(nameCommunication, row.Cert4)
    },
    // 判断撤销按钮显示与隐藏
    judgeShow(row) {
      return row.Source === 'ca_service' && row.Status === 'normal'
    },
    delInfo(row) {
      this.$prompt('请输入组织证书撤销理由', '撤销证书', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^.+$/,
        inputErrorMessage: '请输入撤销原因'
      })
        .then(({ value }) => {
          let param = {
            certId: row.id,
            reason: value
          }
          this.$apis.certificate.revokeCert(param).then(res => {
            this.$message({
              type: 'success',
              message: `组织证书撤销成功！`
            })
          })
          this.refresh()
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消撤销'
          })
        })
    },
    refresh() {
      const { offset, limit } = this.orgPaging
      this.getList(limit * 2, offset * 2)
    }
  }
}
</script>

<style scoped lang="scss">
.ibc-org-certificate.common-certificate {
  .normal-table-wrap {
    height: 100%;
    min-height: var(--common-certificate-list-min-height);

    /deep/ {
      .el-empty {
        height: 100%;
        min-height: var(--common-certificate-list-min-height);
      }

      .normal-table {
        height: 100%;
        min-height: var(--common-certificate-list-min-height);

        .cert-status {
          padding: var(--common-certificate-list-status-padding);
          display: inline-block;
          &.is-normal {
            color: var(--base-color-success);
          }
          
          &.is-cancel {
            color: var(--base-color-danger);
            background-color: rgba(233, 87, 87, 0.34);
          }
        }
      }
    }
  }
}
</style>
